import { http } from 'utils'

const state = {
  //
}

const getters = {
  //
}

const actions = {
  getDashboardData (_context, { refresh = false } = {}) {
    return http.get('dashboards/support', { params: { refresh: refresh ? 1 : undefined } }).then(response => {
      return response
    })
  },
}

const mutations = {
  //
}

export default {
  namespaced: true, state, getters, actions, mutations
}
